module.exports = __webpack_public_path__ + "static/media/10-tips.52f80508.png";